export default __webpack_public_path__ + "static/media/kindpng_6093321_1.1e0eb889.svg";